import { render, staticRenderFns } from "./orderfeeschangedetail.vue?vue&type=template&id=1186deef"
import script from "./orderfeeschangedetail.vue?vue&type=script&lang=ts"
export * from "./orderfeeschangedetail.vue?vue&type=script&lang=ts"
import style0 from "./orderfeeschangedetail.vue?vue&type=style&index=0&id=1186deef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports